import { useNavigate } from "react-router-dom";
import { useModal } from "../utils/demoProvider";

export default function BookConsultation({ title, text, btnText, href }) {
  const { openModal } = useModal();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center gap-8">
      <div className="space-y-4">
        <h1 className="text-[32px] md:text-[54px] font-extrabold text-white leading-[1.2] text-center">
          {title}
        </h1>
        <p className="text-white text-base text-center">{text}</p>
      </div>

      {href ? (
        <button
          onClick={() => navigate(href)}
          className="py-3 px-6 min-w-[170px] text-center bg-[#0073FF] hover:bg-[#0073FF]/70 text-white rounded-[100px] gap-2 transition-colors ease-in duration-300"
        >
          {btnText}
        </button>
      ) : (
        <button
          onClick={openModal}
          className="py-3 px-6 min-w-[170px] text-center bg-[#0073FF] hover:bg-[#0073FF]/70 text-white rounded-[100px] gap-2 transition-colors ease-in duration-300"
        >
          {btnText}
        </button>
      )}
    </div>
  );
}
